import { ProgramType } from '@citruscamps/citrus-client'

interface IValue {
  label: string
  value: string
}

export const getSuggestedByTypes = (types: ProgramType[]): IValue[] => {
  const dayOptions: IValue[] = [{ value: 'All Day', label: 'All Day' }]
  const educationOptions: IValue[] = [
    { value: 'Animation', label: 'Animation' },
    { value: 'Aviation', label: 'Aviation' },
    { value: 'Computer & Tech', label: 'Computer & Tech' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'French', label: 'French' },
    { value: 'Leadership', label: 'Leadership' },
    { value: 'Math', label: 'Math' },
    { value: 'Minecraft', label: 'Minecraft' },
    { value: 'Robotics', label: 'Robotics' },
    { value: 'Science Summer', label: 'Science Summer' },
    { value: 'Stem', label: 'Stem' },
    { value: 'Youth Empowerment', label: 'Youth Empowerment' },
    { value: 'Zoo', label: 'Zoo' },
  ]
  const otherOptions: IValue[] = [
    { value: 'Animation', label: 'Animation' },
    { value: 'Circus', label: 'Circus' },
    { value: 'Cooking', label: 'Cooking' },
    { value: 'Dance', label: 'Dance' },
    { value: 'Drama & Acting', label: 'Drama & Acting' },
    { value: 'Fashion', label: 'Fashion' },
    { value: 'Music Summer', label: 'Music Summer' },
    { value: 'Film and Video', label: 'Film and Video' },
    { value: 'Wilderness', label: 'Wilderness' },
  ]
  const sportsCamps: IValue[] = [
    { value: 'Baseball', label: 'Baseball' },
    { value: 'Basketball', label: 'Basketball' },
    { value: 'Cheer', label: 'Cheer' },
    { value: 'Golf', label: 'Golf' },
    { value: 'Gymnastics', label: 'Gymnastics' },
    { value: 'Hockey', label: 'Hockey' },
    { value: 'Horse Riding', label: 'Horse Riding' },
    { value: 'Lacrosse', label: 'Lacrosse' },
    { value: 'Multi-sports', label: 'Multi-sports' },
    { value: 'Paintball', label: 'Paintball' },
    { value: 'Rock Climbing', label: 'Rock Climbing' },
    { value: 'Sailing', label: 'Sailing' },
    { value: 'Skating', label: 'Skating' },
    { value: 'Soccer', label: 'Soccer' },
    { value: 'Swimming', label: 'Swimming' },
    { value: 'Tennis', label: 'Tennis' },
    { value: 'Trampoline', label: 'Trampoline' },
    { value: 'Volleyball', label: 'Volleyball' },
    { value: 'Wakeboard', label: 'Wakeboard' },
  ]
  return types.length === 0
    ? [...dayOptions, ...educationOptions, ...otherOptions, ...sportsCamps]
    : types.reduce((options: IValue[], type: ProgramType) => {
        switch (type) {
          case 'day':
            return [...options, ...dayOptions]
          case 'education':
            return [...options, ...educationOptions]
          case 'other':
            return [...options, ...otherOptions]
          case 'sports':
            return [...options, ...sportsCamps]
          case 'traditional':
            break
        }
        return options
      }, [])
}
